import { LocalSettingsType } from 'data/Auth/types'

import * as AT from './actionTypes'

export type ReadSettingsActionType = {
  type: typeof AT.READ_SETTINGS
}

export type WriteSettingsActionType = {
  payload: LocalSettingsType
  type: typeof AT.WRITE_SETTINGS
}

export type SetSettingsActionType = {
  payload: LocalSettingsType
  type: typeof AT.SET_SETTINGS
}

export const readSettings = (): ReadSettingsActionType => ({
  type: AT.READ_SETTINGS
})

export const writeSettings = (payload: LocalSettingsType): WriteSettingsActionType => ({
  payload,
  type: AT.WRITE_SETTINGS
})

export const setSettings = (payload: LocalSettingsType): SetSettingsActionType => ({
  payload,
  type: AT.SET_SETTINGS
})

export type LocalSettingsActionType =
  | ReadSettingsActionType
  | WriteSettingsActionType
  | SetSettingsActionType
